import PropTypes from "prop-types";
import { useTranslate } from "src/locales";

import { Box , Stack , Typography , ListItemButton } from '@mui/material';

import { fDate } from "src/utils/format-time";

import Label from "src/components/label";
import Iconify from "src/components/iconify";

// ----------------------------------------------------------------------

export default function ReleasesPopoverItem({ release, onClick }) {
  const { t } = useTranslate();
  const isGuide = release.kind === "guide";

  return (
    <ListItemButton
      onClick={onClick}
      sx={{
        py: 1.5,
        px: 2.5,
        gap: 1.5,
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          flexShrink: 0,
          display: "flex",
          borderRadius: 1,
          alignItems: "center",
          justifyContent: "center",
          color: (isGuide && "secondary.dark") || (release.featured ? "info.main" : "primary.main"),
          bgcolor: (isGuide && "secondary.lighter") || (release.featured ? "info.lighter" : "primary.lighter"),
        }}
      >
        <Iconify
          icon={
            (isGuide && "solar:book-bookmark-bold-duotone") ||
            (release.featured ? "solar:star-bold-duotone" : "solar:rocket-bold-duotone")
          }
          width={20}
        />
      </Box>

      <Stack spacing={0.75} sx={{ minWidth: 0, flexGrow: 1 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {isGuide && (
            <Label color="secondary" variant="soft" sx={{ textTransform: "none" }}>
              Guida
            </Label>
          )}
          {!isGuide && (release.featured ? (
            <Label color="info" variant="soft" sx={{ textTransform: "none" }}>
              {t("product_updates.featured")}
            </Label>
          ) : (
            <Box />
          ))}
          <Typography variant="caption" color="text.disabled">
            {fDate(release.publishedAt)}
          </Typography>
        </Stack>

        <Typography variant="subtitle2" noWrap>
          {release.title}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {release.summary}
        </Typography>
      </Stack>

      <Iconify
        icon="eva:arrow-ios-forward-fill"
        width={18}
        sx={{ mt: 0.5, flexShrink: 0, color: "text.disabled" }}
      />
    </ListItemButton>
  );
}

ReleasesPopoverItem.propTypes = {
  release: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    publishedAt: PropTypes.string.isRequired,
    featured: PropTypes.bool,
    kind: PropTypes.oneOf(["update", "guide"]),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};
